import LayoutWrap from './components/layout/LayoutWrap';


function App() {
  return (
    <>
      <LayoutWrap />
    </>
  );
}

export default App;
